import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import Task from './Task';
import TaskInput from './Input';

import { getTasks } from '../../../../Actions/Dashboard/task';

class TaskList extends React.Component {
  componentDidMount() {
    this.props.dispatch(getTasks(this.props.filter));
  }

  render() {
    return (
      <ul className="cb-blog_listing cb-blog_listing__tools">
        <TaskInput />
        { this.props.tasks.map(task => <Task task={task} key={task.id} />)}
      </ul>
    );
  }
}

TaskList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
};

export default connect(state => ({
  tasks: state.tasks,
  filter: state.taskfilter,
}), dispatch => ({ dispatch }))(TaskList);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/Task/List.jsx